var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"print",staticClass:"printer-iframe",attrs:{"src":_vm.src},on:{"load":_vm.loaded}})}
var staticRenderFns = []

export { render, staticRenderFns }